var _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFav(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26.1036 11.226C25.6354 10.7576 25.0795 10.3861 24.4677 10.1325C23.8558 9.87902 23.2001 9.74854 22.5378 9.74854C21.8755 9.74854 21.2197 9.87902 20.6079 10.1325C19.996 10.3861 19.4401 10.7576 18.9719 11.226L18.0003 12.1977L17.0286 11.226C16.0829 10.2803 14.8002 9.74903 13.4628 9.74903C12.1253 9.74903 10.8427 10.2803 9.89694 11.226C8.95122 12.1718 8.41992 13.4544 8.41992 14.7919C8.41992 16.1293 8.95122 17.412 9.89694 18.3577L10.8686 19.3294L18.0003 26.461L25.1319 19.3294L26.1036 18.3577C26.572 17.8895 26.9436 17.3336 27.1971 16.7218C27.4506 16.1099 27.5811 15.4542 27.5811 14.7919C27.5811 14.1296 27.4506 13.4738 27.1971 12.862C26.9436 12.2501 26.572 11.6942 26.1036 11.226Z",
    stroke: "url(#paint0_linear_160_157467)",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_160_157467",
    x1: 7.70827,
    y1: 9.74853,
    x2: 28.5537,
    y2: 11.0655,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F5EA99"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DB9B45"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFav);
export default __webpack_public_path__ + "static/media/fav.7734fdd0ba62d6a5c8121bc810c93df8.svg";
export { ForwardRef as ReactComponent };